import React, { useState, useEffect } from 'react';
import { signOut } from 'aws-amplify/auth';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import useUserStore from '../../../store/user-store'; // Adjust the import path as necessary
import { FiMenu } from 'react-icons/fi';
import { LuLogOut as LogOut } from "react-icons/lu";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const clearUser = useUserStore((state) => state.clearUser); // Use the clearUser function from the store

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1280) {
        setIsMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleLogout = async () => {
    await signOut();
    localStorage.removeItem('user_id');
    clearUser(); // Clear the user state from the store
    navigate('/');
  };

  const navLinks = [
    { to: "/reports", label: "Reports" },
    { to: "/users", label: "Users" },
    { to: "/organisations", label: "Organisations" },
    { to: "/templates", label: "Templates" },
    { to: "/user-templates", label: "User Templates" },
    { to: "/vocabulary", label: "Vocabulary" },
    { to: "/transactions", label: "Transactions" },

    { to: "/tools", label: "Tools" },
    { to: "/tool-prompts", label: "Tool Prompts" },
    { to: "/models", label: "Models" },
    { to: "/notification", label: "Notification" },
    { to: "/tokens-logs", label: "Tokens Logs" },
    { to: "/error-logs", label: "Error Logs" },
  ];

  return (
    <nav className="bg-gray-800">
      <div className="max-w-screen-3xl mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          <div className={`flex items-center ${isMenuOpen && 'justify-between w-full'}`}>
            <Link to="/" className="text-white font-semibold text-xl">
              MPAssist
            </Link>
            {isMenuOpen && (
              <div className="xl:hidden mr-6">
                <LogOut
                  onClick={handleLogout}
                  className="text-gray-300 cursor-pointer hover:text-white"
                  size={22}
                  title='Log Out'
                />
              </div>
            )}
          </div>
          <div className="hidden lg:flex 3xl:space-x-4 items-center space-x-1.5">
            {navLinks.map((link, index) => (
              <React.Fragment key={link.to}>
                <Link to={link.to} className="text-gray-300 hover:text-white">
                  {link.label}
                </Link>
                {index < navLinks.length - 1 && <span className="text-gray-500">|</span>}
              </React.Fragment>
            ))}
            <LogOut
              onClick={handleLogout}
              className="text-gray-300 cursor-pointer hover:text-white"
              size={24}
              title="Log Out"
            />
          </div>
          <div className="lg:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-300 hover:text-white focus:outline-none"
            >
              <FiMenu size={24} />
            </button>
          </div>
        </div>
        {isMenuOpen && (
          <div className="lg:hidden bg-gray-800 py-4">
            <div className="grid grid-cols-2 md:grid-cols-6 lg:grid-cols-7 gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-gray-300 hover:text-white text-center"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
